import React from 'react';
import { FormattedHTMLMessage, injectIntl, InjectedIntl } from 'react-intl';
import {
    VerificationService,
    getOptions,
} from '@sheerid/jslib';

interface PrivacyPolicyLinkProps {
    verificationService: VerificationService;
    intl?: InjectedIntl;
}

const PrivacyPolicyLink = ({ verificationService, intl }: PrivacyPolicyLinkProps) => {
    const programTheme = verificationService ? verificationService.programTheme : undefined;
    const privacyPolicyHref = getOptions().privacyPolicyUrl;

    return (
        <a className="sid-privacy-policy sid-link" href={privacyPolicyHref} target="_blank">
            <FormattedHTMLMessage id="privacyPolicy" defaultMessage="Privacy Policy" />
        </a>
    );
};

export const PrivacyPolicyLinkComponent = injectIntl(PrivacyPolicyLink);
